{
  "file": "Fichier",
  "upload_file": "Uploader un fichier",
  "accepted": "Fichiers accepté",
  "any": "Tous fichiers",
  "drag": "Glisser",
  "or": "ou",
  "browse_files": "Chercher un fichier",
  "file_submit": "Ajouter un fichier",
  "order": "Ordre",
  "field_required": "Ce champs est obligatoire"
}
